<div class="card">
  <div class="card-header">
    <button type="button" (click)="showHistorySettings = !showHistorySettings" class="btn btn-link py-0"><i class="fas" [ngClass]="{ 'fa-plus-circle': !showHistorySettings, 'fa-minus-circle': showHistorySettings }"></i>&nbsp;History Settings</button>
  </div>
  <div class="card-body" *ngIf="showHistorySettings">
    <div class="form-group row">
      <div class="col-4">
        <label>Title</label>
      </div>
      <div class="col-8">
        <input type="text" class="form-control" [(ngModel)]="billing.title" />
      </div>
    </div>
    <div class="form-group row">
      <div class="col-4">
        <label>Reminder Date</label>
      </div>
      <div class="col-8">
        <app-datepicker [blankInitially]="true" (date_result)="billing.reminder_date = $event"></app-datepicker>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-4">
        <label>Additional Emails</label>
      </div>
      <div class="col-8">
        <input type="text" class="form-control" [(ngModel)]="billing.other_emails" />
      </div>
    </div>
    <div class="form-group">
      <div class="custom-control custom-checkbox" (click)="billing.notify_accounting = !billing.notify_accounting">
        <input [checked]="billing.notify_accounting" [(ngModel)]="billing.notify_accounting" type="checkbox" class="custom-control-input" />
        <label class="custom-control-label">Notify Accounting</label>
      </div>
    </div>
  </div>
</div>
<div class="form-group row mt-3">
  <div class="col-7">
    <select class="form-control" [(ngModel)]="billing.activity_id" (change)="activityChange()">
      <option *ngFor="let activity of formOptions.activities" [value]="activity.value">{{ activity.label }}</option>
    </select>
  </div>
  <div class="col-5">
    <select class="form-control" [(ngModel)]="billing.user_id" (change)="getRate()">
      <option *ngFor="let user of formOptions.users" [value]="user.value">{{ user.label }}</option>
    </select>
  </div>
</div>
<div class="form-group row">
  <div class="col-3">
    <label>Time</label>
  </div>
  <div class="col-5">
    <input type="text" class="form-control text-right" [(ngModel)]="quantity" [disabled]="!activityRate.allow_time" (change)="manualTimeRateChange()" (click)="pauseOnly()" />
  </div>
  <div class="col-4 text-center">
    <button type="button" class="btn btn-outline-primary w-100 text-left" (click)="startTimer()" [disabled]="!timerPaused"><i class="fas fa-play-circle"></i> Start</button>
  </div>
</div>
<div class="form-group row">
  <div class="col-3">
    <label>X Rate</label>
  </div>
  <div class="col-5">
    <div class="input-group">
      <div class="input-group-prepend"><span class="input-group-text">$</span></div>
      <input class="form-control text-right" type="text" [(ngModel)]="billing.rate" [disabled]="!activityRate.allow_rate" (change)="manualTimeRateChange()" />
    </div>
  </div>
  <div class="col-4 text-center">
    <button type="button" class="btn btn-outline-primary w-100 text-left" (click)="pauseTimer()" [disabled]="timerPaused"><i class="fas fa-pause-circle"></i> Stop</button>
  </div>
</div>
<div class="form-group row">
  <div class="col-3">
    <label>Fee</label>
  </div>
  <div class="col-5">
    <div class="input-group">
      <div class="input-group-prepend"><span class="input-group-text">$</span></div>
      <input class="form-control text-right" type="text" [(ngModel)]="totalCharge" [disabled]="!activityRate.allow_total" />
    </div>
  </div>
  <div class="col-4 text-center">
    <button type="button" class="btn btn-outline-primary w-100 text-left" (click)="resetTimer(true, true)"><i class="fas fa-stop-circle"></i> Reset</button>
  </div>
</div>
<div class="form-group row">
  <div class="col-4">
    <div class="custom-control custom-checkbox">
      <input
        type="checkbox"
        class="custom-control-input"
        [id]="'billingRecordTimeBillable' + matter_id"
        [checked]="billing.is_billable"
        [(ngModel)]="billing.is_billable"
        (change)="billingChanges.is_billable = true"
      />
      <label class="custom-control-label" [attr.for]="'billingRecordTimeBillable' + matter_id">Billable</label>
    </div>
  </div>
  <div class="col-8">
    <div class="row">
      <div class="col-3">
        <div class="pt-1">Date</div>
        &nbsp;
      </div>
      <div class="col-9">
        <app-datepicker (date_result)="billing.rendered_at = $event" [full_width]="true"></app-datepicker>
      </div>
    </div>
  </div>
</div>
<div class="form-group">
  <label>Description</label>
  <textarea class="form-control" [(ngModel)]="billing.description" (change)="billingChanges.description = true"></textarea>
</div>
<div class="form-group">
  <label>Extra History</label>
  <textarea class="form-control" [(ngModel)]="billing.history_message"></textarea>
</div>
<div class="form-group text-center">
  <button type="button" class="btn btn-primary" [disabled]="savingBilling" (click)="addBilling()">
    {{ savingBilling ? 'Adding' : 'Add' }}<span *ngIf="savingBilling">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span>
  </button>
</div>
